import { CarModel } from './car.model';
import { UniversalCarBrand } from './universal.car.brand';

export class UniversalCarModel extends CarModel {
    CatalogCarModels: { [key: string]: CarModel[] };
    override Brand: UniversalCarBrand;
}
